import { render } from "./PageNotFound.vue?vue&type=template&id=a24fef3e&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=a24fef3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a24fef3e"

export default script